{
    "Timezone_Title_Change": "Modifier le fuseau horaire de l'utilisateur",
    "Timezone_Title_Update": "Mettre à jour le fuseau horaire de l'utilisateur",
    "Timezone_Dropdown_Title": "Fuseau horaire",
    "Timezone_Tab_General": "Général",
    "Timeline_Prompt_Change": "Changement",
    "Timeline_Prompt_Cancel": "Annuler",
    "Timeline_Prompt_Change_Message": "Nous avons détecté une modification de votre fuseau horaire utilisateur \n \n Il était à l'origine **{}** \n \n Souhaitez-vous modifier votre fuseau horaire local en **{}**",
    "Timeline_Prompt_First_Time_Message": "Votre fuseau horaire de rapport actuel est défini sur **{}** \n \n Souhaitez-vous mettre à jour vos rapports selon votre fuseau horaire local **{}**",
    "NAME": "TimezoneModal"
}